<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_iii"></a><strong>THE BEST<br/>GAME EVER</strong></h1>
<p class="stitle"><strong>Giants vs. Colts, 1958, and the Birth of the Modern NFL</strong></p>
<p class="author"><strong>MARK BOWDEN</strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?080df5ff